import * as actNotif from 'actions/notifications';
import * as action from 'actions';
import { call, put } from 'redux-saga/effects';
import * as apiCustomers from 'api/customers';

export function* customerServiceRetrieveImportTemplate(fileId) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    const response = yield call(
      apiCustomers.customerServiceRetrieveImportTemplate,
      fileId
    );
    return response.data;
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}

export function* customerServiceRetrieveExportTemplate(fileId) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    const response = yield call(
      apiCustomers.customerServiceRetrieveExportTemplate,
      fileId
    );
    return response.data;
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}
